import horizonPolyfillJs from './raw/horizon-polyfills?raw';

export function HorizonPolyfillScript() {
  return (
    <script
      dangerouslySetInnerHTML={{
        // These polyfills are enough to support Chrome 69
        __html: horizonPolyfillJs,
      }}
    />
  );
}
